import { createSlice } from '@reduxjs/toolkit';

import type { UserState } from '../../../types/appState';
import { getWidgetRuntimeData } from '../thunks/widgetRuntime.thunk';

const initialState: UserState = {
  countryCode: '',
  id: '',
  profileImage: '',
  email: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWidgetRuntimeData.fulfilled, (state, action) => {
      if (action.payload.user) {
        state = action.payload.user;
      }
    });
  },
});
